function ReportFilterInstance() {
    "use strict";

    this.__type = 'ReportFilterInstance:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.ReportId = -1;
    this.ReportInstanceId = -1;
    this.ReportFilterId = -1;
    this.Value = '';
    this.Text = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = ReportFilterInstance;
}